import { render, staticRenderFns } from "./OnboardingForms.vue?vue&type=template&id=033f8316&"
import script from "./OnboardingForms.vue?vue&type=script&lang=js&"
export * from "./OnboardingForms.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports